import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=d0b4894e&scoped=true&"
import script from "./Schedule.vue?vue&type=script&lang=js&"
export * from "./Schedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b4894e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d0b4894e', component.options)
    } else {
      api.reload('d0b4894e', component.options)
    }
    module.hot.accept("./Schedule.vue?vue&type=template&id=d0b4894e&scoped=true&", function () {
      api.rerender('d0b4894e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/clients/Schedule.vue"
export default component.exports